import { getTvObject, tv } from '@costar-ui/cosmos';

var tagGroupTV = getTvObject({
  slots: {
    tagList: 'flex w-full flex-wrap gap-1'
  },
  variants: {
    direction: {
      horizontal: {
        tagList: "flex-row"
      },
      vertical: {
        tagList: 'flex-col'
      }
    }
  }
});
var base = tv(tagGroupTV);
var tagGroupStyles = {
  base: base
};

export { tagGroupStyles, tagGroupTV };
//# sourceMappingURL=tag-group.styles.esm.js.map
